export const SCHEDULE_SEARCH_MEMBER_JANES_PER_PAGE = 30;
